<script>
import { Pie } from "vue-chartjs";
import ChartPluginLabel from 'chartjs-plugin-labels';
//import ChartDataLabels from 'chartjs-plugin-datalabels';

export default {
  extends: Pie,
  plugins: [ChartPluginLabel],
  props: {
    chartdata: {},
    options: {}
  },
  mounted() {
    //this.addPlugin(this.plugins)
    this.renderChart(this.chartdata, this.options)
  }
};
</script>